import type {PageRouteConfig} from '@router';

import {type HeaderDataPayload} from '@ds/types';
import {useRouteBuildContext} from '@router';
import CustomDealSelectProducts from 'modules/Services/PromotionCenter/CustomDeal/SelectProducts/SelectProducts';
import {routes} from 'routes/routes';

function CustomDealSelectProductsPageElement() {
  const ctx = useRouteBuildContext();

  return (
    <CustomDealSelectProducts
      headerData={({icon, action, title, hasHeader}: HeaderDataPayload) => {
        ctx.updateHeaderData('customDealSelectProducts', {icon, action, title, hasHeader});
      }}
    />
  );
}

export function createPromotionCenterCustomDealSelectProductsRoute(): PageRouteConfig {
  return {
    element: <CustomDealSelectProductsPageElement />,
    layout: {
      title: 'ایجاد تخفیف جدید',
      headerDataKey: 'customDealSelectProducts',
      hasHeader: true,
      hasBack: true,
      hasLeftIcon: false,
      link: routes.PROMOTION_CENTER_CUSTOM_DEAL
    },
    initialHeaderData: {
      customDealSelectProducts: {icon: '', iconTitle: '', action: null, title: 'انتخاب کالاها'}
    }
  };
}
